<template>
    <v-data-table
        :headers="headers"
        :items="ships"
        class="elevation-1"
        >

        <template v-slot:item="props">
            <tr>
                <td class="text-left">{{ props.item.type }}</td>
                <td class="text-left">{{ props.item.quantity }}</td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>

export default {
    props: {
        time: null
    },
    name: 'GlobalShipsPanel',
    data() {
        return {
            headers: [
                { text: 'Type', value: 'type' },
                { text: 'Quantity', value: 'quantity' }
            ]
        };
    },
    computed: {
        ships() {
            let ships = this.time.scene.getAllShips();
            let workingShips = ships.filter((ship) => {
                return !!ship.livingQuarters.crew.length;
            });

            return [
                {
                    type: 'Working',
                    quantity: workingShips.length
                },
                {
                    type: 'Derelict',
                    quantity: ships.length - workingShips.length
                }
            ];
        }
    }
};
</script>